const defaultDashboard = state => structuredClone(state.defaultDashboard);

const selectedDashboard = state => structuredClone(state.selectedDashboard);

const supervisorDashboards = state => structuredClone(state.supervisorDashboards);

const selectedSupervisorDashboard = state => state.selectedSupervisorDashboard;

const selectedSupervisorDashboardComponent = state => {
  return state.supervisorDashboards.find(({ key }) => state.selectedSupervisorDashboard === key).componentName;
};

export default {
  // Agent
  defaultDashboard,
  selectedDashboard,

  // Supervisor
  supervisorDashboards,
  selectedSupervisorDashboard,
  selectedSupervisorDashboardComponent
};
